import { Routes } from '@angular/router';
import { redirectIfLoggedInGuard, requireLoginGuard } from '@guard';
import { LivePickupShellComponent } from './live-pickup-shell.component';
import { LivePickupViewComponent } from './live-pickup-view.component';

export const LIVE_PICKUP_APP_ROUTES: Routes = [
  {
    path: 'transmission',
    loadComponent: async () =>
      (await import('@account/feature')).AuthTokenReceiverComponent,
  },
  {
    path: 'sign-in',
    canActivate: [redirectIfLoggedInGuard('/')],
    loadComponent: async () =>
      (await import('./sign-in/sign-in.component')).SignInComponent,
  },
  {
    path: '',
    component: LivePickupShellComponent,
    canActivate: [requireLoginGuard('/sign-in')],
    children: [
      {
        path: '',
        component: LivePickupViewComponent,
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
